<smw-icon [icon]="icon" />
<div class="body-sm">
  <ng-content />
</div>
